import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.add-to-text.loud {
    padding-left: 8px;
}
.add-to-watchlist-btn {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    height: 32px;
    padding-left: calc(8px * 2);
    padding-right: calc(8px * 2);
    white-space: nowrap;
    width: 100%;
    position: relative;
}
.icon-minus-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.99935 15.3332C12.0494 15.3332 15.3327 12.0499 15.3327 7.99984C15.3327 3.94975 12.0494 0.666504 7.99935 0.666504C3.94926 0.666504 0.666016 3.94975 0.666016 7.99984C0.666016 12.0499 3.94926 15.3332 7.99935 15.3332Z' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 8H4' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}
.icon-plus-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.99935 15.3332C12.0494 15.3332 15.3327 12.0499 15.3327 7.99984C15.3327 3.94975 12.0494 0.666504 7.99935 0.666504C3.94926 0.666504 0.666016 3.94975 0.666016 7.99984C0.666016 12.0499 3.94926 15.3332 7.99935 15.3332Z' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 8H4' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8 12L8 4' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}
.add-to-watchlist-btn.loud {
    height: calc(8px * 5);
    width: 168px;
    padding: 8px calc(8px * 2);
    font-size: 16px;
    color: #086ea1;
}
.add-to-watchlist-btn.is-added {
    color: #248647;
}
.add-to-watchlist-btn.is-added.loud {
    margin-left: 0;
}
.add-to-watchlist-btn.is-added.watchlist-remove {
    color: #ffffff;
}
.added-icon-img {
    padding-right: 8px;
}
:global(.tippy-tooltip.dark-theme) {
    padding: 0;
    border-radius: 5px;
    background-color: #ffffff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
:global(.tippy-tooltip.dark-theme .tippy-backdrop) {
    background-color: #ffffff;
}
:global(.tippy-tooltip.dark-theme[x-placement^='top'] .tippy-arrow) {
    border-top-color: #ffffff;
}
@media (max-width: 720px) {
    .add-to-watchlist-btn {
        display: flex;
        align-items: center;
        margin-right: 0;
        max-width: 100px;
    }
    .add-to-watchlist-btn.loud {
        max-width: unset;
    }
    .add-to-watchlist-btn.is-added {
        color: #ffffff;
    }
    .add-to-watchlist-btn.is-added.loud {
        color: #248647;
        padding: 0;
    }

    .watchlist-action-icon {
        float: left;
        display: inline-block;
        border-radius: 100%;
        width: 26px;
        height: 26px;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 8px;
        position: relative;
    }

    .add-to-text.loud {
        padding-left: 20px;
    }
}
`;

export default styles;